/** @format */

export const shippingOptions = {
  SHIP: {
    label: 'Ship',
    subtitle: 'Find items in stock to ship',
    icon: 'fulfillment-shipping-outline',
  },
  BOPIS: {
    label: 'Pickup',
    subtitle: 'One-hour curbside or in-store',
    icon: 'fulfillment-pickup-outline',
  },
  ISA: {
    label: 'Shopping In-Store',
    subtitle: 'Find items in stock at your store',
    icon: 'fulfillment-in-store-shopping-fill',
  },
  SDD: {
    label: 'Same Day Delivery',
    subtitle: 'Find items available for same day delivery',
    icon: 'fulfillment-sameday-outline',
  },
};

export type ShippingOption = (typeof shippingOptions)[keyof typeof shippingOptions];

// New copy Update for ship and pickup
export const shippingOptionsNew = {
  SHIP: {
    label: 'Ship',
    subtitle: 'Find items in stock to ship',
    icon: 'fulfillment-shipping-outline',
  },
  BOPIS: {
    label: 'Store Pickup',
    subtitle: 'One-hour curbside or in-store',
    icon: 'fulfillment-pickup-outline',
  },
  ISA: {
    label: 'Shopping In-Store',
    subtitle: 'Find items in stock at your store',
    icon: 'fulfillment-in-store-shopping-fill',
  },
  SDD: {
    label: 'Same Day Delivery',
    subtitle: 'Find items available for same day delivery',
    icon: 'fulfillment-sameday-outline',
  },
};

export const selectableShippingOptions = {
  BOPIS: {
    label: 'Free Store Pickup',
    subtitleOption: 'Ready within 1 hour',
    icon: {
      unselected: 'fulfillment-pickup-outline',
      selected: 'fulfillment-pickup-fill',
    },
  },
  ISA: {
    label: 'Shop In-Store',
    subtitleOption: 'Purchase in-store today',
    icon: {
      unselected: 'fulfillment-in-store-shopping-fill',
      selected: 'fulfillment-in-store-shopping-fill',
    },
  },
  SDD: {
    label: 'Same Day Delivery',
    subtitleOption: 'Order by 4PM for same-day delivery',
    icon: {
      unselected: 'fulfillment-sameday-outline',
      selected: 'fulfillment-sameday-fill',
    },
  },
  SHIP: {
    label: 'Ship to Me',
    subtitleOption: 'Find in-stock items to ship',
    icon: {
      unselected: 'fulfillment-shipping-outline',
      selected: 'fulfillment-shipping-fill',
    },
  },
};

export const FULFILLMENT_SECTION_LABELS = {
  selectable: {
    pickup: { sddEnabled: 'Pickup at', sddDisabled: 'Pickup or Shop at' },
    ship: { label: 'Ship to' },
  },
  chip: {
    BOPIS: 'Pickup at',
    SHIP: 'Ship to',
    SDD: 'Deliver to',
    ISA: 'My store',
  },
  ctaPlaceholder: {
    store: 'Select Store',
    zip: 'Update Delivery Location',
  },
} as const;
